import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy
} from '@angular/router';

@Injectable()
export class KeepAliveRouteReuseStrategy implements RouteReuseStrategy {

  private cache = new Map<string, DetachedRouteHandle>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return route.data?.['keepAlive'] === true;
  }

  store(
    route: ActivatedRouteSnapshot,
    handle: DetachedRouteHandle
  ): void {
debugger;
    const key = this.getRouteKey(route);

    if (!key) {
      return;
    }

    console.log('STORE:', key);

    this.cache.set(key, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {

    const key = this.getRouteKey(route);

    if (!key) {
      return false;
    }

    const result = this.cache.has(key);

    console.log('ATTACH?', key, result);

    return result;
  }

  retrieve(
    route: ActivatedRouteSnapshot
  ): DetachedRouteHandle | null {

    const key = this.getRouteKey(route);

    if (!key) {
      return null;
    }

    console.log('RETRIEVE:', key);

    return this.cache.get(key) ?? null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {

    return future.routeConfig === curr.routeConfig;
  }

  private getRouteKey(
    route: ActivatedRouteSnapshot
  ): string {

    return route.data?.['cacheKey'] ?? '';
  }

  clear(key: string): void {
    this.cache.delete(key);
  }

  clearAll(): void {
    this.cache.clear();
  }
}